var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInquiry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1247_22020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9131 44.0869C9.90062 42.0744 11.235 37.8459 10.2113 35.3697C9.14813 32.8125 5.25 30.7344 5.25 28C5.25 25.2656 9.14813 23.1875 10.2113 20.6303C11.235 18.1562 9.90062 13.9256 11.9131 11.9131C13.9256 9.90062 18.1562 11.235 20.6303 10.2113C23.1984 9.14813 25.2656 5.25 28 5.25C30.7344 5.25 32.8125 9.14813 35.3697 10.2113C37.8459 11.235 42.0744 9.90062 44.0869 11.9131C46.0994 13.9256 44.765 18.1541 45.7888 20.6303C46.8519 23.1984 50.75 25.2656 50.75 28C50.75 30.7344 46.8519 32.8125 45.7888 35.3697C44.765 37.8459 46.0994 42.0744 44.0869 44.0869C42.0744 46.0994 37.8459 44.765 35.3697 45.7888C32.8125 46.8519 30.7344 50.75 28 50.75C25.2656 50.75 23.1875 46.8519 20.6303 45.7888C18.1562 44.765 13.9256 46.0994 11.9131 44.0869Z",
    stroke: "#2D5049",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 42C29.4497 42 30.625 40.8247 30.625 39.375C30.625 37.9253 29.4497 36.75 28 36.75C26.5503 36.75 25.375 37.9253 25.375 39.375C25.375 40.8247 26.5503 42 28 42Z",
    fill: "#2D5049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 31.5V29.75C31.8653 29.75 35 27.0069 35 23.625C35 20.2431 31.8653 17.5 28 17.5C24.1347 17.5 21 20.2431 21 23.625V24.5",
    stroke: "#2D5049",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_22020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquiry);
export default __webpack_public_path__ + "static/media/inquiry.43c8018d39f4754bb85f07ef99392449.svg";
export { ForwardRef as ReactComponent };